import {
  AUTH_CODE,
  AUTH_CODE_IS_BUREAU,
  IS_BUREAU,
} from '@nxsys/store/constants/keys';

/**
 * An auth_code carries only a bare user id, and both databases mint ids from
 * their own `USRP-<n>` sequence — so the same id is a different person in each.
 * The target system must therefore come from the flag captured at the same
 * moment as the code, not from IS_BUREAU, which is rewritten independently
 * (switchSystem, restorePreviousAuthState) and would silently resolve the id
 * against the other database.
 */
export const resolveAuthTarget = () => {
  const stored = localStorage.getItem(AUTH_CODE);
  const authCode = stored ? JSON.parse(stored) : null;
  const boundIsBureau = localStorage.getItem(AUTH_CODE_IS_BUREAU);

  // Sessions established before this key existed have no bound flag yet.
  const isBureau =
    authCode && boundIsBureau !== null
      ? boundIsBureau === 'true'
      : localStorage.getItem(IS_BUREAU) === 'true';

  return { authCode, isBureau };
};
